<template>
  <div class="candidates-container">
    <div class="header">
      UNSERE KANDIDATEN
    </div>
    <div class="separator"></div>
    <div class="flexbox">
      <div class="candidate-tile tile grid-item" v-for="candidate in
        candidates" :key="candidate.name">
        <candidate-tile :candidate="candidate"/>
      </div>
    </div>

    <div class="back-button" @click="goBack()">
      <i class="fas fa-chevron-circle-left"></i>
    </div>

  </div>
</template>

<script>
import CandidateTile from '@/components/CandidateTile.vue'
import candidates from "../data/candidates.json"

export default {
  name: 'Candidates',
  components: {
    CandidateTile
  },
  data() {
    return{
      candidates: candidates,
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.candidates-container{
  position: relative;
}

.flexbox {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 80px;
}

.grid {
  margin-top: 5px;                                                                             
  margin-left: 10px;                                                                             
  margin-right: 10px;                                                                             
  margin-bottom: 40px;                                                                         
  display: grid;                                                                               
  grid-template-columns: 50% 50%;
  grid-row-gap: 5px;                                                                           
}                                                                                              
                                                                                         
.grid-item{                                                                            
  width: 95%;
  max-width: 380px;
  margin: 10px;
  background-color: white;
  color: $gText; 
  font-size: 0.8em;                                                                             
} 

.separator {
  height: 5px;
  background-color: $secondary;
  margin-bottom: 30px;
}

.candidate-tile {
  display: inline-block;
  cursor: pointer;

  @include shadow;
  border-radius: $border-radius;
  margin: 10px;
  overflow: hidden;

  position: relative;

  background-color: white;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.back-button {
  position: absolute;
  bottom: 20px;
  right: 20px;
  font-size: 40px;
}


</style>
